import CloseIcon from "@mui/icons-material/Close";

export function DeleteAnnouncementForm({ isOpen,
  onClose,
  handleDelete }
) {
  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Delete!</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <span>Are you sure you want to delete this announcement?</span>
            </div>
            <div className="buttons row" style={{ justifyContent: "center", padding: "40px 40px 20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={handleDelete}
                style={{ marginRight: "5px" }}>
                DELETE
              </button>
              <button id="add-family"
                className="cancel row"
                onClick={() => handleClose()}>
                CANCEL
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}